export const defaultStore = {
  isLoggedIn: false,
  reloadClient: false,
  xolasClient: {},
  org: {},
  profile: {},
  stats: {},
  statsError: false,
  debug: false,
  isChrome: null,
  isSafari: null,
  env: null,
  endpoint: null,
  hostname: null,
  copyright: null,
  windowWidth: null,
  windowHeight: null
}



// WEBPACK FOOTER //
// ./src/components/config/store.js